export default __webpack_public_path__ + "static/media/GrandMaster.69fd0b07.svg";